import {
  T0,
  Block,
  media,
  WarningIcon,
} from 'ia-react-core';
import styled from 'styled-components';

export const StyledText = styled.span`
  font-size:14px;
`;

export const StyledT0 = styled(T0)`
  margin-bottom: 0px;
`;

export const StyledIcon = styled(WarningIcon)`
  color: ${({ theme }) => theme.colors.orange2};
`;

export const StyledBlock = styled(Block)`
  width: 100%;
  margin-left: -16px;
  margin-bottom: 36px;
  ${media.sm`
    padding-left: 32px !important;
    padding-right: 32px !important;
    margin-left: -32px;
  `};
  box-shadow: rgb(0 0 0 / 6%) 0px 2px 0px 0px;
  border-radius: 0;
`;
